import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

export const useVestingStructure = ({
  companyId,
  planId,
  stakeholderId,
  enabled,
}: {
  companyId: string;
  enabled?: boolean;
  planId: string;
  stakeholderId: string;
}) => {
  const queryClient = useQueryClient();

  const { data: vestingStructure, isLoading } = useAppQuery<{
    exercisable: number;
    exercised: number;
    granted: number;
    sharesVested: number;
    totalGrantVested: number;
  }>({
    queryKey: [QueryKey.GET_VESTING_TASKS_STRUCTURE, companyId, planId, stakeholderId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', stakeholderId, 'plan', planId, 'vesting-structure'],
      }),
    enabled: !!companyId && !!planId && !!stakeholderId && enabled,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_VESTING_TASKS_STRUCTURE] });
  }, [queryClient]);

  return {
    invalidateQuery,
    vestingStructure,
    isLoading,
  };
};
